/* review labs registered */
export const GET_REVIEW_PERFORMANCE = "GET_REVIEW_PERFORMANCE";
export const GET_REVIEW_PERFORMANCE_SUCCESS =
  "GET_REVIEW_PERFORMANCE_SUCCESS";
export const GET_REVIEW_PERFORMANCE_FAIL = "GET_REVIEW_PERFORMANCE_FAIL";


// review offered tests added

export const GET_REVIEW_PERFORMANCE_TEST = "GET_REVIEW_PERFORMANCE_TEST";
export const GET_REVIEW_PERFORMANCE_TEST_SUCCESS =
  "GET_REVIEW_PERFORMANCE_TEST_SUCCESS";
export const GET_REVIEW_PERFORMANCE_TEST_FAIL = "GET_REVIEW_PERFORMANCE_TEST_FAIL";